import React, { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import {
  EXPLORER_BTN_SHADOW,
  EXPLORER_CHIP_BG,
  EXPLORER_SEARCH_ROW_HEIGHT,
} from "../explorerTheme";

type ExplorerNameFilterRowProps = {
  onOpenNameSearch: () => void;
  onApplyFilters: () => void;
};

const rowHeight = EXPLORER_SEARCH_ROW_HEIGHT;

const ExplorerNameFilterRow: React.FC<ExplorerNameFilterRowProps> = ({
  onOpenNameSearch,
  onApplyFilters,
}) => (
  <Box sx={{ mb: 2.5 }}>
    <Typography
      sx={{
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 1.2,
        color: "#111",
        mb: 1,
        pl: 0,
      }}
    >
      Name
    </Typography>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        width: "100%",
      }}
    >
      <Box
        role="button"
        tabIndex={0}
        onClick={onOpenNameSearch}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onOpenNameSearch();
          }
        }}
        aria-label="Open search plant list"
        sx={{
          flex: 1,
          minWidth: 0,
          height: rowHeight,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 1,
          borderRadius: 999,
          bgcolor: "#fafafa",
          border: "1px solid #d0d0d0",
          px: 2,
          py: 0,
          cursor: "pointer",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        <Box
          aria-hidden
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 22,
            height: 22,
            flexShrink: 0,
          }}
        >
          <SearchIcon
            sx={{
              color: "#9e9e9e",
              fontSize: 20,
              display: "block",
            }}
          />
        </Box>
        <Box
          component="span"
          sx={{
            flex: 1,
            minWidth: 0,
            alignSelf: "stretch",
            display: "flex",
            alignItems: "center",
            fontSize: 14,
            fontWeight: 400,
            color: "#9e9e9e",
            lineHeight: 1,
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          Search by name
        </Box>
      </Box>
      <Button
        variant="contained"
        disableElevation
        onClick={onOpenNameSearch}
        sx={{
          flexShrink: 0,
          height: rowHeight,
          minHeight: rowHeight,
          maxHeight: rowHeight,
          px: 2.25,
          py: 0,
          borderRadius: "12px",
          fontWeight: 700,
          fontSize: 14,
          lineHeight: 1,
          textTransform: "none",
          bgcolor: EXPLORER_CHIP_BG,
          color: "#111",
          boxShadow: EXPLORER_BTN_SHADOW,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: 88,
          "&:hover": {
            bgcolor: "#dde3dd",
            boxShadow: EXPLORER_BTN_SHADOW,
          },
        }}
      >
        Search
      </Button>
    </Box>
  </Box>
);

export default memo(ExplorerNameFilterRow);
